var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChatCircleText = function SvgIconChatCircleText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.49 4.035a7.99 7.99 0 0 0-7.373 12.049 1 1 0 0 1 .102.782l-.757 2.672 2.672-.756a1 1 0 0 1 .782.102 7.991 7.991 0 1 0 4.574-14.85m-6.627.084a9.99 9.99 0 1 1 1.416 16.7l-2.71.767a1.74 1.74 0 0 1-2.155-2.155l.767-2.71A9.99 9.99 0 0 1 5.863 4.12M8 10.125a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2H9a1 1 0 0 1-1-1m0 3.75a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2H9a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};
export default SvgIconChatCircleText;